var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('BundlePurchaseOptionCard',{attrs:{"product":_vm.product,"useCarousel":_vm.useCarousel,"showFrequencies":_vm.showFrequencies},on:{"hasFrequencies":function (val){ return _vm.$emit('hasFrequencies', val); }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }